import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function SmsPolicy() {
	return (
		<>
			<Helmet>
				<title>SMS Policy | Apex Specialty Contracting LLC</title>
				<meta name="description" content="SMS messaging policy for Apex Specialty Contracting LLC. Learn how we use text messages, how to opt out, and your rights." />
			</Helmet>
			<PageHeader
				title="SMS Messaging Policy"
				subtitle="How APEX SPECIALTY CONTRACTING LLC uses text messaging and your opt-out rights."
			/>
			<section className="section">
				<div className="container">
					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>Who Sends These Messages?</h2>
						<p className="helper">Text messages are sent by <strong>APEX SPECIALTY CONTRACTING LLC</strong>, operating as Appex Connect Hub, located at 183 Highland Rd, Tarpon Springs, FL 34689. Phone: (916) 316-0696. Email: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>.</p>
					</div>

					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>What Types of Messages Do We Send?</h2>
						<p className="helper">When you opt in, you may receive text messages related to:</p>
						<ul className="helper" style={{ paddingLeft: 18 }}>
							<li><strong>Estimate reminders</strong> — follow-ups on your requested roofing estimate or inspection</li>
							<li><strong>Appointment confirmations &amp; reminders</strong> — scheduling information for inspections, installations, and repairs</li>
							<li><strong>Project status updates</strong> — milestone notifications during active roofing projects</li>
							<li><strong>Promotional offers</strong> — seasonal discounts, special offers, and company announcements</li>
							<li><strong>Service notifications</strong> — warranty registrations, weather alerts, and post-project follow-ups</li>
						</ul>
					</div>

					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>How to Opt In</h2>
						<p className="helper">You can opt in to receive SMS messages from us by:</p>
						<ul className="helper" style={{ paddingLeft: 18 }}>
							<li>Checking the SMS consent box on our website contact or estimate request form</li>
							<li>Texting START to our business number after previously opting out</li>
							<li>Verbally providing consent when scheduling a service appointment</li>
						</ul>
						<p className="helper"><strong>Consent is not required to receive roofing services.</strong></p>
					</div>

					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>How to Opt Out (STOP)</h2>
						<p className="helper">You may opt out of SMS messages at any time by:</p>
						<ul className="helper" style={{ paddingLeft: 18 }}>
							<li>Replying <strong>STOP</strong> to any text message we send</li>
							<li>Visiting our <a href="/opt-out">Opt-Out page</a> and submitting your phone number</li>
							<li>Contacting us at <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a> or (916) 316-0696</li>
						</ul>
						<p className="helper">After you send STOP we will confirm your unsubscription. You will not receive further messages unless you opt back in.</p>
					</div>

					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>Help &amp; Support</h2>
						<p className="helper">Reply <strong>HELP</strong> to any message to receive contact information. You may also reach us at:</p>
						<ul className="helper" style={{ paddingLeft: 18 }}>
							<li>Email: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a></li>
							<li>Phone: <a href="tel:9163160696">(916) 316-0696</a></li>
							<li>Address: 183 Highland Rd, Tarpon Springs, FL 34689</li>
						</ul>
					</div>

					<div className="card" style={{ padding: 24, marginBottom: 20 }}>
						<h2 style={{ marginTop: 0 }}>Message Frequency &amp; Rates</h2>
						<ul className="helper" style={{ paddingLeft: 18 }}>
							<li><strong>Message frequency varies</strong> based on your active projects and preferences.</li>
							<li><strong>Message and data rates may apply</strong> based on your wireless carrier plan.</li>
							<li>Carriers are not liable for delayed or undelivered messages.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: 24 }}>
						<h2 style={{ marginTop: 0 }}>Standard Disclosure</h2>
						<p className="helper">
							By opting in, you agree to receive recurring marketing text messages from APEX SPECIALTY CONTRACTING LLC at the mobile number provided.
							Msg &amp; data rates may apply. Message frequency varies. Reply <strong>STOP</strong> to opt out at any time. Reply <strong>HELP</strong> for assistance.
							Consent is not a condition of purchase or service.
						</p>
						<p className="helper" style={{ marginTop: 10 }}>
							For our full Privacy Policy, visit <a href="/privacy">appexconnecthub.com/privacy</a>. For Terms of Use, visit <a href="/terms">appexconnecthub.com/terms</a>.
						</p>
					</div>
				</div>
			</section>
		</>
	);
}

export default SmsPolicy;